import '../css/CVItem.css'

const CVItem = (props) => {
  return (
    <div className="cv-item">
      <div className="cv-item-left">
        <div className="time-interval">{props.time}</div>
      </div>
      <div className="cv-item-right">
        <h3 className="cv-item-name">{props.name}</h3>
        <p className="cv-item-desc">{props.desc}</p>
        <ul>
          {props.points.map((point) => {
            return <li className="cv-item-point">{point}</li>
          })}
        </ul>
      </div>
    </div>
  )
}

export default CVItem
